import { CardVariant } from "../../../models/CardVariant";
import { IFilterCommand } from "../IFilterCommand";

export type JobFilterArgs = {
    jobs: string[] | null | undefined,
    isAnd: boolean
}

export class JobFilter<TItem extends CardVariant> implements IFilterCommand<TItem, JobFilterArgs> {
    isMatch(item: TItem, args: JobFilterArgs = { jobs: [], isAnd: false }): boolean {
        // No types provided, which means we're not filtering on type.
        if (!args.jobs?.length) {
            return true;
        }

        const cardJobs = item?.card?.jobs || [];
        if (!cardJobs) {
            return false;
        }

        let isMatch = args.isAnd ? true : false;
        for (const item of args.jobs) {
            isMatch = args.isAnd
                ? (isMatch && cardJobs.some((x) => x === item))
                : (isMatch || cardJobs.some((x) => x === item));
        }

        return isMatch;
    }
}